export enum ClientTitle {
    None = 'None', //default
    Other = 'Other',
    Owner = 'Owner',
    Administrator = 'Administrator'
}



// WEBPACK FOOTER //
// ./src/app/models/request-and-responses/rest-api/enums/clientTitle.ts